import AdPostback from './AdPostback';
export default AdPostback;
